"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _vuex = _interopRequireDefault(require("vuex"));
var _app = _interopRequireDefault(require("./modules/app"));
var _user = _interopRequireDefault(require("./modules/user"));
var _tagsView = _interopRequireDefault(require("./modules/tagsView"));
var _permission = _interopRequireDefault(require("./modules/permission"));
var _settings = _interopRequireDefault(require("./modules/settings"));
var _activity = _interopRequireDefault(require("./modules/activity"));
var _getters = _interopRequireDefault(require("./getters"));
var _groupManage = _interopRequireDefault(require("./modules/group-manage"));
_vue.default.use(_vuex.default);
var store = new _vuex.default.Store({
  modules: {
    app: _app.default,
    user: _user.default,
    tagsView: _tagsView.default,
    permission: _permission.default,
    activity: _activity.default,
    settings: _settings.default,
    groupManage: _groupManage.default
  },
  getters: _getters.default
});
var _default = exports.default = store;